module.exports = __webpack_public_path__ + "images/store_case_study/article-pic2_c028ebff8c90680d6f9bc7b3f275d41d.png";